import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class IntegracaoOpendeliveryService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  salveParametrizacaoMerchant(integracao: any){
    return this.facaPost('/opendelivery/merchant/params', integracao)
  }

  ativeIntegracaoComerciante(integracao){
    return this.facaPost('/opendelivery/merchant/ative', integracao)
  }
  desativeIntegracaoComerciante(integracao){
    return this.facaPost('/opendelivery/merchant/desative', integracao)
  }

  salveParametrizacaoLogistica(integracao: any){
    return this.facaPost('/opendelivery/logistica/params', integracao)
  }

  listeParceirosConhecidosLogistica(){
    return this.obtenha('/opendelivery/logistica/parceiros-conhecidos', {})
  }

  testeAutenticacaoLogistica(integracao: any){
    return this.facaPost('/opendelivery/logistica/teste-autenticacao', integracao)
  }

  testeApiLogistica(integracao: any){
    return this.facaPost('/opendelivery/logistica/teste-api', integracao)
  }


  ativeIntegracaoLogistica(integracao: any){
    return this.facaPost('/opendelivery/logistica/ative', integracao)
  }

  desativeIntegracaoLogisca(integracao: any){
    return this.facaPost('/opendelivery/logistica/desative', integracao)
  }


  gereChaves(){
    return this.facaPost('/opendelivery/orderapp/keys', {})
  }

  obtenhaSoftwareService(){
    return this.obtenha('/opendelivery/software-service', {})
  }

  salveSoftwareService(integracao: any){
    return this.facaPost('/opendelivery/software-service/params', integracao)
  }

  inicieAutorizacaoSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/oauth/start', {id: integracaoId})
  }

  testeAutenticacaoSoftwareService(integracao: any){
    return this.facaPost('/opendelivery/software-service/auth/test', integracao)
  }

  gereCredenciaisSoftwareService(integracao: any){
    return this.facaPost('/opendelivery/software-service/credentials/generate', {id: integracao && integracao.id})
  }

  executeOnboardingSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/onboarding', {id: integracaoId})
  }

  atualizeWebhookSoftwareService(integracaoId: number, urlWebhook: string){
    return this.facaPost('/opendelivery/software-service/webhook/update', {id: integracaoId, urlWebhook})
  }

  testePollingSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/polling/test', {id: integracaoId})
  }

  ativePollingSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/polling/activate', {id: integracaoId})
  }

  ativeSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/activate', {id: integracaoId})
  }

  desativeSoftwareService(integracaoId: number){
    return this.facaPost('/opendelivery/software-service/deactivate', {id: integracaoId})
  }

  listeStatusSoftwareService(){
    return this.obtenha('/opendelivery/software-service/lojas/status', {})
  }
}
